import store from "../../../store";
import imcdashboard from './index.vue';


window.DASHBOARD =  new Vue({
    store,
    el: '#imc_vue_component',
    name : "DASHBOARD",
    created () {

    },
    components : {
        imcdashboard
    }
})
